'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var Radio = require('./Radio');

var RadioGroup = function (_React$Component) {
  _inherits(RadioGroup, _React$Component);

  function RadioGroup() {
    _classCallCheck(this, RadioGroup);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  RadioGroup.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(
      'div',
      { className: 'cf-radio__group' },
      this.props.options.map(function (option) {
        return React.createElement(Radio, {
          key: option.name,
          label: option.label,
          name: option.name,
          value: option.value,
          checked: _this2.props.value === option.value,
          onChange: _this2.props.onChange });
      })
    );
  };

  return RadioGroup;
}(React.Component);

RadioGroup.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]).isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired
};


module.exports = RadioGroup;